module.exports = __webpack_public_path__ + "png/quick-registration-coin-3.png?9d464cf0dacdfb0c12deb032d124e33b";